import { render } from "./page-market-trends.vue?vue&type=template&id=114fd80f"
import script from "./page-market-trends.js?vue&type=script&lang=js"
export * from "./page-market-trends.js?vue&type=script&lang=js"

import "./page-market-trends.vue?vue&type=style&index=0&id=114fd80f&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__